module.exports = __webpack_public_path__ + "static/media/pulsidL.526c06ef.webp";